export function isNumber(value: any): value is number {
  return typeof value === 'number';
}

export function isNumberFinite(value: any): value is number {
  return isNumber(value) && isFinite(value);
}

export function isPositive(value: number): boolean {
  return value >= 0;
}

export function isInteger(value: number): boolean {
  // No rest, is an integer
  return value % 1 === 0;
}

export function toDecimal(value: any, decimal: number): number {
  return Math.round(value * Math.pow(10, decimal)) / Math.pow(10, decimal);
}

export function calculateMinutes(hours: any, minutes: any) {
  return Math.floor(hours) * 60 + Math.floor(minutes);
}

export function addZeroes(num: any) {
  return parseFloat(num).toFixed(
    Math.max(((parseFloat(num) + '').split('.')[1] || '').length, 2)
  );
}
